import { render, staticRenderFns } from "./Prenota.vue?vue&type=template&id=1d3b0e60&scoped=true&"
import script from "./Prenota.vue?vue&type=script&lang=js&"
export * from "./Prenota.vue?vue&type=script&lang=js&"
import style0 from "./Prenota.vue?vue&type=style&index=0&id=1d3b0e60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3b0e60",
  null
  
)

export default component.exports